import { orderTypeCode } from '@/constants/global';
import { trimSpace } from '@/utils';
export default {
    /**
     * 검색 필터된 주문 리스트 조회
     * @param orderList
     * @param searchOrderQuery 검색어
     * @returns
     */
    getOrdersWithSearchQuery(orderList = {}, _searchOrderQuery = '') {
        let searchKeys = [
            'orderId',
            'hubName',
            'todayNumber',
            'storeName',
            'allocatedWorkerName',
            'allocatedHubName',
        ];
        let filteredOrderList = {};
        const searchOrderQuery = _searchOrderQuery.toLowerCase();
        if (searchOrderQuery) {
            Object.entries(orderList).forEach(([key, order]) => {
                const isQuick = order.typeCode === orderTypeCode.QUICK;
                const trimmed = order._trimAddress();
                // 퀵일 경우 출발지주소 사용 , 출발지주소있으면 출발지주소, delivery중 픽업메모가 없으면 상점이름, 픽업메모있으면 픽업메모
                const targetText = isQuick
                    ? trimmed.fullPickupAddress ?? ''
                    : (trimmed.pickupAddressMemo || trimmed.storeName) ?? '';
                // 검색어 길이가 4개 이하일때에는 orderId 제외하고 검색
                searchKeys = searchOrderQuery.length <= 4 ? searchKeys.filter((item) => item !== 'orderId') : searchKeys;
                const filteredOrder = Object.entries(order).filter((id) => searchKeys.includes(id[0]));
                const hasSearchOrderQuery = this.searchCondition(filteredOrder, searchOrderQuery);
                if (targetText.toLowerCase().includes(searchOrderQuery)
                    || hasSearchOrderQuery
                    || trimmed.fullDropAddressShorten.toLowerCase().includes(searchOrderQuery)) {
                    filteredOrderList[key] = order;
                }
            });
        }
        else {
            filteredOrderList = orderList;
        }
        return filteredOrderList;
    },
    /**
     * 검색조건
     * @param filteredOrder 오더에서 조건필드만 필터한 내용
     * @param searchOrderQuery 검색어
     * @returns
     */
    searchCondition(filteredOrder, searchOrderQuery) {
        return filteredOrder.some(([, value,]) => trimSpace(value?.toString())?.toLowerCase().includes(searchOrderQuery));
    },
};
